import { validate } from "../../utils/validate"
import { toast } from "./toast/index.web"
import { Overlay } from "./overlay/overlay.web"

// let useAddDlgFn: null | ((dlgList: React.ReactChild[]) => void) = null

const overlay = new Overlay()

export const ui = {
  /**
   * 初始化函数
   */
  init(cfg?: { dialog?: (dlgList: React.ReactNode[]) => void }) {
    // useAddDlgFn = useAddDlg
  },
  showDlg(element: React.ReactElement): () => void {
    throw new Error("Function not implemented.")
  },
  showPicker(props: PickerProps) {
    throw new Error("Function not implemented.")
  },
  showDrawer(element: React.ReactElement) {
    throw new Error("Function not implemented.")
  },
  showSubscreen(element: React.ReactElement) {
    throw new Error("Function not implemented.")
  },
  toast(content: string = "", duration: "long" | "short" = "short") {
    validate.String(content, "content")
    if (duration && duration !== "long" && duration !== "short") {
      throw Error(`duration must be "long" or "short"`)
    }
    toast(content, duration)
  },
  fullScreen(enable = false) {
    throw new Error("Function not implemented.")
  },
  fullScreenByApp(enable = false) {
    throw new Error("Function not implemented.")
  },
  intercept(titles: string[], callback: () => void) {
    throw new Error("Function not implemented.")
  },
  loading(config?: {
    showListener?: () => void
    dismissListener?: () => void
    isCancelable?: boolean
  }) {
    return {
      show: () => { },
      hide: () => { }
    }
  },
  showOverlay(data: any) {
    overlay.showOverlay(data)
  },
  hideOverlay() {
    overlay.hideOverlay()
  }
}
